import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  OrdersPaymentRequest,
  OrdersPaymentRequestStatusEnum
} from '~/lazy/payments/pages/new-payment/models/ordersPaymentRequest';
import { StatusScreenTypeEnum } from '@qvs/core';
import { TranslatePipe } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';
import { NgIf } from '@angular/common';
import { StatusScreenComponent } from '~/shared/components/status-screen/status-screen.component';
import { AmountPipe } from '~/shared/pipes/amount.pipe';
import { LocalDatePipe } from '~/shared/pipes/local-date.pipe';
import { AccountIdShortenPipe } from '~/shared/pipes/account-id-shorten.pipe';

@Component({
  selector: 'qvs-validate-payment-order-request-uploading',
  templateUrl: './validate-payment-order-request-uploading.component.html',
  styleUrls: ['./validate-payment-order-request-uploading.component.scss'],
  standalone: true,
  imports: [NgIf, IonicModule, TranslatePipe, StatusScreenComponent, AmountPipe, LocalDatePipe, AccountIdShortenPipe]
})
export class ValidatePaymentOrderRequestUploadingComponent {
  @Input() ordersPaymentRequest: OrdersPaymentRequest;
  @Output() closed: EventEmitter<boolean> = new EventEmitter<boolean>();

  readonly status = OrdersPaymentRequestStatusEnum;
  readonly statusScreenType = StatusScreenTypeEnum;

  close() {
    this.closed.emit();
  }
}
